import React, { useContext, useState } from "react";
import { User, UserCircle, ShoppingBag, Package, LogIn, LogOut, ChevronRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { postData } from "../../services/NodeServices";
import { MyContext } from "../../context/MyContext";

const ProfileDropdown = ({ isLoggedIn, navigate, user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);

  const {isloggedIn,setUser} =useContext(MyContext)

  const handleMouseEnter = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setIsOpen(false);
    }, 150); // Small delay to prevent flickering
    setHoverTimeout(timeout);
  };

  const handleItemClick = (path) => {
    if(path=='/logout'){
         console.log('state removed')
        localStorage.removeItem('user')
        navigate('/')
       
        setIsOpen(false);

    }else{
    setIsOpen(false);
    navigate(path);
    }
  };


  const handleLogOut = async() =>{

   try{

    localStorage.removeItem('user')
    navigate('/')
   }
   catch{


   }

  }

  const loggedInMenuItems = [
    {
      icon: UserCircle,
      label: "My Profile",
      path: "/userinfo",
      accent: true
    },
    {
      icon: Package,
      label: "My Orders",
      path: "/orders"
    },
  /*   {
      icon: ShoppingBag,
      label: "My Purchases",
      path: "/purchases"
    }, */
    {
      icon: LogOut,
      label: "Logout",
      path:'/logout',
      divider: true
    }
  ];

  const guestMenuItems = [
    {
      icon: LogIn,
      label: "Sign In",
      path: "/log-in",
      accent: true,
      fullWidth: true
    }
  ];

  const menuItems = isLoggedIn ? loggedInMenuItems : guestMenuItems;

  return (
    <div 
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Profile Icon Button */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="p-2 text-gray-700 hover:text-gray-900 transition-colors relative"
      >
        <User size={20} />
        {isLoggedIn && (
          <motion.div 
            className="absolute -top-[-4px] -right-[-4px] w-2 h-2 bg-orange-500 rounded-full"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2 }}
          />
        )}
      </motion.button>

      {/* Dropdown Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="absolute right-0 mt-1 w-48 bg-white border border-gray-100 rounded-lg shadow-lg z-50 overflow-hidden"
            style={{ 
              boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)" 
            }}
          >
            {/* Header Section */}
            {isLoggedIn && user ? (
              <div className="px-3 py-3 bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-100">
                <div className="flex items-center space-x-2">
                  <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center">
                    <User size={12} className="text-white" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-gray-900 truncate tracking-tight">
                      Hello, {user.firstName || user.name?.split(' ')[0] || "User"}! 👋
                    </p>
                    <p className="text-xs text-gray-500 truncate">
                      {user.email || "user@example.com"}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="px-3 py-3 text-center border-b border-gray-100">
                <p className="text-xs font-medium text-gray-900 tracking-tight mb-1">
                  Welcome to Blaze! 👋
                </p>
                <p className="text-xs text-gray-500">
                  Sign in to access your account
                </p>
              </div>
            )}

            {/* Menu Items */}
            <div className="py-1">
              {menuItems.map((item, index) => (
                <React.Fragment key={index}>
                  {item.divider && <div className="border-t border-gray-100 my-1" />}
                  
                  {item.fullWidth ? (
                    // Special styling for login button
                    <div className="px-3 py-2">
                      <motion.button
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => handleItemClick(item.path)}
                        className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-4 py-2 rounded-lg transition-all shadow-sm hover:shadow-md"
                      >
                        <item.icon size={14} className="text-white" />
                        <span className="text-xs font-medium tracking-tight">
                          {item.label}
                        </span>
                      </motion.button>
                    </div>
                  ) : (
                    // Regular menu items
                    <motion.button
                      whileHover={{ backgroundColor: "rgb(249 250 251)" }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => handleItemClick(item.path)}
                      className={`w-full flex items-center justify-between px-3 py-2 text-left transition-colors group ${
                        item.accent 
                          ? "hover:bg-orange-50 text-gray-900" 
                          : "hover:bg-gray-50 text-gray-700"
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <item.icon 
                          size={14} 
                          className={`${
                            item.accent 
                              ? "text-orange-500 group-hover:text-orange-600" 
                              : "text-gray-500 group-hover:text-gray-600"
                          } transition-colors`}
                        />
                        <span className={`text-xs font-medium tracking-tight ${
                          item.accent 
                            ? "text-gray-900" 
                            : "text-gray-700"
                        } group-hover:text-gray-900 transition-colors`}>
                          {item.label}
                        </span>
                      </div>
                      
                      <ChevronRight 
                        size={12} 
                        className="text-gray-400 opacity-0 group-hover:opacity-100 transition-all transform group-hover:translate-x-1" 
                      />
                    </motion.button>
                  )}
                </React.Fragment>
              ))}
            </div>

            {/* Footer (only if logged in) */}
            {isLoggedIn && (
              <div className="px-3 py-2 bg-gray-50 border-t border-gray-100">
                <p className="text-xs text-gray-500 text-center tracking-tight">
                  Manage your account
                </p>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ProfileDropdown;